import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  LoadStudentGroupings,
  ResetStudentGroupings,
} from 'Src/ng2/store/actions/student-groupings-actions/student-groupings-actions';
import { IStudentGroupingsPayload } from 'Src/ng2/store/actions/student-groupings-actions/student-groupings-actions';
import {
  getStudentGroupingsData,
  getStudentGroupingsLoadedStatus,
} from 'Src/ng2/store/selectors/student-groupings-selectors/student-groupings-selectors';

@Injectable()
export class StudentGroupingsResolver {
  resolveStudentGroupingsData$(store: Store<any>, payload: IStudentGroupingsPayload): Promise<Observable<any>> {
    store.dispatch(new ResetStudentGroupings());
    const destroy$: Subject<boolean> = new Subject<boolean>();
    return new Promise(resolve => {
      store
        .select(getStudentGroupingsLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe((loaded: boolean) => {
          if (!loaded) store.dispatch(new LoadStudentGroupings(payload));
          if (loaded) {
            const studentGroupingsData$ = store.select(getStudentGroupingsData);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(studentGroupingsData$);
          }
        });
    });
  }
}
